export enum rarityEnum {
  common = "common",
  silver = "silver",
  gold = "gold",
}
